import type { users as en } from '@/i18n/locales/en/users';
import type { Translation } from '@/i18n/types';

export const users: Translation<typeof en> = {
  page: {
    title: 'Usuarios',
    noScope:
      'No tienes ningún ámbito administrativo, así que no hay una lista de miembros que mostrar.',
    departmentListsTitle: 'Listas de miembros por departamento',
    leadCompany: 'Miembros de {{company}}.',
    membersOf: 'Miembros de {{company}}',
    companyMembersCardTitle: 'Miembros',
    addPerson: 'Añadir persona',
    empty: 'No hay miembros.',
    name: 'Nombre',
    email: 'Correo electrónico',
    login: 'Acceso',
    source: 'Origen',
    yes: 'sí',
    no: 'no',
    invitePerson: 'Invitar',
    importCsv: 'Importar CSV',
    searchPlaceholder: 'Buscar por nombre o correo…',
    filterDepartment: 'Departamento',
    allDepartments: 'Todos los departamentos',
    filterLocation: 'Ubicación',
    allLocations: 'Todas las ubicaciones',
    filterStatus: 'Estado',
    allStatuses: 'Todos los estados',
    employee: 'Empleado',
    department: 'Departamento',
    location: 'Ubicación',
    lastSync: 'Última sincronización',
    consent: 'Consentimiento',
    wearable: 'Wearable',
    pilot: 'Piloto',
    account: 'Cuenta',
    actions: 'Acciones',
    accountActive: 'Activo',
    accountDeactivated: 'Desactivado',
    noLocation: 'Sin ubicación',
    noDepartment: 'Sin departamento',
    activation: {
      label: 'Activación',
      invited: 'Invitado',
      activated: 'Activado',
      active: 'Activo',
      inactive: 'Inactivo',
      deactivated: 'Desactivado',
    },
    consentStatus: {
      pending: 'Pendiente',
      confirmed: 'Confirmado',
      declined: 'Retirado',
      none: 'Ninguno',
    },
  },
  detail: {
    thisPerson: 'esta persona',
    edit: 'Editar',
    name: 'Nombre',
    email: 'Correo electrónico',
    nickname: 'Apodo',
    preferredLanguage: 'Idioma preferido',
    region: 'Región',
    login: 'Acceso',
    yes: 'sí',
    no: 'no',
    gender: 'Género',
    birthdate: 'Fecha de nacimiento',
    height: 'Altura',
    weight: 'Peso',
    privateNote:
      'El género, la fecha de nacimiento, la altura y el peso son privados para esta persona y no forman parte de la vista que otros tienen de ella.',
    actionsCardTitle: 'Acciones',
    statsCardTitle: 'Estadísticas',
  },
  edit: {
    title: 'Editar datos personales',
    lead: 'El nombre y el correo electrónico provienen de la cuenta de inicio de sesión y no se pueden cambiar aquí.',
    cancel: 'Cancelar',
    save: 'Guardar',
  },
  addPerson: {
    created: 'Persona creada.',
    inviteSent: 'Un correo de invitación está en camino.',
    alreadyHasLogin: 'Ya tienen acceso.',
    noLoginYet: 'Aún no tienen acceso — puedes invitarles más tarde desde la lista de miembros.',
    done: 'Hecho',
    name: 'Nombre',
    email: 'Correo electrónico',
    emailHint: 'Opcional — con uno, se invita a la persona a iniciar sesión.',
    nickname: 'Apodo',
    region: 'Región',
    conflict:
      'Ya existe una persona con este correo electrónico{{reason}}. Añade a esa persona existente al ámbito en lugar de crear un duplicado.',
    cancel: 'Cancelar',
    create: 'Crear persona',
    companyTitle: 'Añadir una persona a la empresa',
    departmentTitle: 'Añadir una persona al departamento',
    newPersonCardTitle: 'Nueva persona',
    existingCardTitle: 'Miembro existente de la empresa',
    existingPersonCardTitle: 'Persona existente',
    member: 'Miembro',
    person: 'Persona',
    choose: 'Elige…',
    addToDepartment: 'Añadir al departamento',
    addToCompany: 'Añadir a la empresa',
    searchPeople: 'Buscar personas',
    searchPlaceholder: 'Nombre o correo electrónico',
    noEligible: 'No se ha encontrado ninguna persona coincidente.',
    editionMismatch:
      'La edición de esta persona difiere de la de la empresa. Cambia primero la edición de la persona o de la empresa, y vuelve a intentarlo.',
  },
  actions: {
    invite: 'Invitar',
    inviteAgain: 'Invitar de nuevo',
    changeEmail: 'Cambiar correo electrónico',
    newEmail: 'Nueva dirección de correo electrónico',
    save: 'Guardar',
    cancel: 'Cancelar',
    remove: 'Quitar',
    unlink: 'Desvincular',
    unlinkFromPilot: 'Desvincular del piloto',
    erase: 'Borrar',
    changeLocation: 'Cambiar ubicación',
    changeDepartment: 'Cambiar departamento',
    deactivate: 'Desactivar',
    activate: 'Activar',
  },
  invite: {
    title: 'Invitar a una persona',
    name: 'Nombre',
    email: 'Dirección de correo electrónico',
    role: 'Rol',
    roleMember: 'Empleado',
    roleAdmin: 'Administrador de la empresa',
    submit: 'Invitar',
    cancel: 'Cancelar',
  },
  import: {
    title: 'Importar CSV',
    instructions: 'Pega o sube un CSV con las columnas: nombre, correo, departamento, ubicación.',
    csvLabel: 'CSV',
    placeholder: 'Jane Doe,jane@example.com,Sales,DC Rotterdam',
    uploadLabel: 'O sube un archivo',
    submit: 'Importar',
    cancel: 'Cancelar',
    done: 'Hecho',
    summary: '{{imported}} importados, {{failed}} fallidos.',
    rowLabel: 'Fila {{row}}',
    rowSuccess: 'Importado',
    rowFailed: 'Fallido',
  },
};
